export const EntId = "10006";
export const ScopeId = "99";
export const ChecklistGroupType = "checklist";
